import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

export default RangePicker;
